export default (): boolean => typeof window !== "undefined";
